/* Skapad av Claude Code — svd-productblock-bundle-v2 (CRO-version 2026-07-03).
   Port av v1 (svd-productblock-bundle.js) med:
   - Addon-koden borttagen (bekräftat död kod — ingen markup renderar data-bundle-addon)
   - Per-månad-koden borttagen (renderades aldrig i v1-markup)
   - GWP läses från sektionens data-gwp-rule (produkt-metafältet svd.gwp_rule, JSON:
     {"gift_variant_id":123,"subscription_only":true}) istället för block-settings.
     Gåvoraden får _gwp-flaggan; gwp-motorn i svd-functions gör den gratis.
   - UpCart-/tema-drawer-/upsell-popup-hanteringen är oförändrad från v1. */
(function () {
  'use strict';

  // ============== Helpers ==============
  function fmtMoneyKr(cents) {
    // Shopify prices är i cents (öre). Visa avrundat till hela kronor (rent).
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
    if (cur === 'SEK') return Math.round(cents / 100).toString() + ' kr';
    // EU-marknader: valutamedveten formatering (data-price kommer redan i marknadens valuta)
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function getDataNumber(el, key) {
    var raw = el && el.getAttribute('data-' + key);
    if (!raw) return 0;
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  // ============== Cart drawer-appen UpCart (spegel av v1) ==============
  function hasUpCart() {
    return !!(window.upcart || document.querySelector('[id*="upcart" i], [class*="upcart" i]'));
  }

  function tryOpenUpCart() {
    try {
      if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; }
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); }
    } catch (e) { /* UpCart auto-öppnar normalt själv — detta är bara backup */ }
  }

  // ============== Temats cart drawer (Vision 2024) — spegel av v1 ==============
  var DRAWER_SECTIONS = [
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function sectionInnerHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderDrawerSections(response) {
    if (!response || !response.sections) return;
    DRAWER_SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = response.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var inner = sectionInnerHTML(html, s.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    if (typeof window.CartDrawer !== 'undefined') {
      new window.CartDrawer();
    }
  }

  function openThemeCartDrawer(response) {
    var drawerEl = document.getElementById('Cart-Drawer');
    if (!drawerEl) return false;

    renderDrawerSections(response);

    document.body.classList.add('open-cc');
    drawerEl.classList.add('active');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    return true;
  }

  // ============== Bundle Controller ==============
  function initBundle(root) {
    if (root.__svdBundleV2Init) return;
    root.__svdBundleV2Init = true;

    var weightButtons   = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-weight]'));
    var variantsEl      = root.querySelector('[data-bundle-variants]');
    var variants        = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-variant]'));
    var cta             = root.querySelector('[data-bundle-cta]');
    var ctaPrices       = root.querySelector('[data-bundle-cta-prices]');
    var ctaNow          = root.querySelector('[data-bundle-cta-now]');
    var ctaWas          = root.querySelector('[data-bundle-cta-was]');
    var ctaLabel        = root.querySelector('[data-bundle-cta-label]');
    var modeGroup       = root.querySelector('[data-bundle-mode-group]');
    var modeButtons     = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-mode]'));

    var subscriptionEnabled = root.getAttribute('data-subscription-enabled') !== 'false';

    if (weightButtons.length === 0 || !variantsEl || !cta || variants.length === 0) return;

    // GWP-regeln från produkt-metafältet svd.gwp_rule (via data-attribut).
    // Två format stöds:
    //   {"gift_variant_id":123,"subscription_only":true}                        (en gåva)
    //   {"gifts":[{"gift_variant_id":123,"subscription_only":true}, ...]}       (flera gåvor)
    // Valfritt per gåva: "main_variant_ids":[...] — gåvan läggs BARA när vald huvudvariants
    // id finns i listan (t.ex. Tjurmuskel endast 300g/450g, inte 150g).
    // Valfritt per gåva: "min_main_quantity":2 — gåvan läggs BARA när huvudradens antal
    // är minst så många (t.ex. H&P där paketen är samma variant × 1/2/3 flaskor).
    // Valfritt per gåva: "gift_quantity":2 — gåvoraden läggs med det antalet (utelämnad = 1),
    // t.ex. 2× Benbuljong 100 ml i Grand Slam-offern.
    // Valfritt per gåva: "gift_variant_by_locale":{"fi":111,"nl":222,...,"default":333}
    // i stället för gift_variant_id — varianten väljs efter kundens språk (t.ex. e-bok
    // med en språkvariant per marknad). Appregeln måste lista ALLA språkvarianterna
    // (motorn gör bara raden gratis — den väljer aldrig språk).
    // Saknas/trasig JSON → ingen gåva läggs (gwp-motorn rabatterar bara, den kan inte lägga till).
    var gwpGifts = [];
    function gwpVariantFor(gift) {
      var map = gift.gift_variant_by_locale;
      if (map && typeof map === 'object') {
        var loc = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '')
          .split('-')[0].toLowerCase();
        var picked = map[loc] != null ? map[loc] : map['default'];
        return parseInt(picked, 10) || 0;
      }
      return parseInt(gift.gift_variant_id, 10) || 0;
    }
    try {
      var rawRule = root.getAttribute('data-gwp-rule');
      if (rawRule) {
        var parsed = JSON.parse(rawRule);
        if (parsed && Array.isArray(parsed.gifts)) gwpGifts = parsed.gifts;
        else if (parsed && (parsed.gift_variant_id || parsed.gift_variant_by_locale)) gwpGifts = [parsed];
      }
    } catch (e) {
      console.warn('[svd-bundle-v2] ogiltig svd.gwp_rule', e);
    }

    var state = {
      weightKey: '',
      selectedRow: null,
      mode: subscriptionEnabled ? (root.getAttribute('data-bundle-mode') || 'subscription') : 'onetime',
      plan: null
    };

    var initialSelected = variants.find(function (v) { return v.getAttribute('data-selected') === 'true'; });
    if (initialSelected) {
      state.selectedRow = initialSelected;
    } else if (variants[0]) {
      state.selectedRow = variants[0];
      variants[0].setAttribute('data-selected', 'true');
    }

    // Aktivt pris per variant: prenumerationspris i prenumerationsläge, annars engångspris
    function activePrice(v) {
      return (state.mode === 'subscription' && subscriptionEnabled)
        ? getDataNumber(v, 'sub-price')
        : getDataNumber(v, 'price');
    }

    // Struket pris per läge: pren jämför mot ordinarie pris (sub-compare) så
    // sparbeloppet matchar kassan, som alltid stryker variantpriset — engångsläget
    // jämför mot jämförelsepriset (Eriks val 2026-08-24, uppgiften "Ett problem
    // för alla GSO med prenumeration").
    function activeCompare(v) {
      if (state.mode === 'subscription' && subscriptionEnabled) {
        var sc = getDataNumber(v, 'sub-compare');
        if (sc > 0) return sc;
      }
      return getDataNumber(v, 'compare-price');
    }

    // ============== Render days + per-rad pris (spegel av v1) ==============
    function renderDays() {
      var w = state.weightKey;
      variants.forEach(function (v) {
        var days = getDataNumber(v, 'days-' + w);
        var price = activePrice(v);
        var daysEls = v.querySelectorAll('[data-bundle-days]');
        daysEls.forEach(function (el) {
          el.textContent = days > 0 ? String(days) : '—';
        });

        var nowEl = v.querySelector('[data-bundle-total-now]');
        if (nowEl) nowEl.textContent = fmtMoneyKr(price);

        var wasEl = v.querySelector('[data-bundle-total-was]');
        if (wasEl) {
          var refPrice = activeCompare(v);
          if (refPrice > price) { wasEl.textContent = fmtMoneyKr(refPrice); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      });
    }

    // ============== Prenumeration: plan-val (variant×vikt, 9-cells — spegel av v1) ==============
    function applySnap() {
      var sel = state.selectedRow;
      var planId = sel ? (sel.getAttribute('data-plan-' + state.weightKey) || '').trim() : '';
      state.plan = (state.mode === 'subscription' && subscriptionEnabled && planId) ? planId : null;
      renderCadence();
    }

    function renderCadence() {
      variants.forEach(function (v) {
        var cadEl = v.querySelector('[data-bundle-cadence]');
        if (!cadEl) return;
        var days = getDataNumber(v, 'days-' + state.weightKey);
        cadEl.textContent = days > 0 ? String(days) : '—';
      });
    }

    // ============== Selection ==============
    function selectVariant(row) {
      state.selectedRow = row;
      variants.forEach(function (v) {
        var isSel = v === row;
        v.setAttribute('data-selected', isSel ? 'true' : 'false');
        var radio = v.querySelector('[data-bundle-radio]');
        if (radio) radio.checked = isSel;
      });
      // Minsta paketet valt? (index 1) → CSS växlar USP-texten till usp_text_small (spegel av v1:s hide-smallest)
      root.setAttribute('data-smallest-selected', (row && row.getAttribute('data-variant-index') === '1') ? 'true' : 'false');
      // Offer-stack-dragspelet (Grand Slam 2026-08-15): is-open flyttas ENDAST när det
      // valda kortet har en stack — väljer man ett kort UTAN stack (150g) ligger den
      // senast öppnade stacken kvar (Eriks beslut: 30 dos ska inte stänga 60-dosaren).
      if (row && row.querySelector('.svd-b2__oswrap')) {
        variants.forEach(function (v) { v.classList.toggle('is-open', v === row); });
      }
      applySnap();
      renderCta();
    }

    // ============== CTA total + state (spegel av v1, utan addons) ==============
    function renderCta() {
      if (ctaLabel) {
        var lblSub = cta.getAttribute('data-cta-label-subscription');
        var lblOne = cta.getAttribute('data-cta-label-onetime');
        var lbl = (state.mode === 'subscription' && subscriptionEnabled) ? lblSub : lblOne;
        if (lbl) ctaLabel.textContent = lbl;
      }

      var hasWeight = !!state.weightKey;
      if (!hasWeight) {
        cta.setAttribute('disabled', 'disabled');
        if (ctaPrices) ctaPrices.hidden = true;
        return;
      }
      cta.removeAttribute('disabled');

      var sel = state.selectedRow;
      if (!sel) {
        if (ctaPrices) ctaPrices.hidden = true;
        return;
      }

      var price = activePrice(sel);
      var compare = activeCompare(sel);

      if (ctaNow) ctaNow.textContent = fmtMoneyKr(price);

      if (ctaWas) {
        if (compare > price) {
          ctaWas.textContent = fmtMoneyKr(compare);
          ctaWas.hidden = false;
        } else {
          ctaWas.hidden = true;
        }
      }
      if (ctaPrices) ctaPrices.hidden = false;
    }

    // ============== Reveal variants on weight pick (spegel av v1) ==============
    function setWeight(key) {
      state.weightKey = key || '';
      variantsEl.hidden = !state.weightKey;
      weightButtons.forEach(function (btn) {
        btn.setAttribute('aria-checked', btn.getAttribute('data-bundle-weight') === state.weightKey ? 'true' : 'false');
      });
      if (modeGroup) {
        if (subscriptionEnabled) {
          modeGroup.hidden = false;
          modeButtons.forEach(function (b) { b.disabled = !state.weightKey; });
        } else {
          modeGroup.hidden = true;
        }
      }
      renderDays();
      applySnap();
      renderCta();
    }

    // ============== Köpläge: prenumeration / engångsköp (spegel av v1) ==============
    function setMode(mode) {
      if (mode !== 'subscription' && mode !== 'onetime') return;
      if (mode === 'subscription' && !subscriptionEnabled) mode = 'onetime';
      state.mode = mode;
      root.setAttribute('data-bundle-mode', mode);
      modeButtons.forEach(function (btn) {
        var on = btn.getAttribute('data-bundle-mode') === mode;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      renderDays();
      applySnap();
      renderCta();
    }

    // ============== Add to cart (spegel av v1, GWP via metafälts-regel) ==============
    function addToCart() {
      if (cta.hasAttribute('disabled')) return;
      if (!state.selectedRow) return;

      var selRow = state.selectedRow;
      var qty = parseInt(selRow.getAttribute('data-quantity'), 10) || 1;
      var items = [{ id: parseInt(selRow.getAttribute('data-variant-id'), 10), quantity: qty }];

      // Prenumeration: fäst vald frekvens selling_plan på HUVUDraden.
      if (state.mode === 'subscription' && state.plan) {
        items[0].selling_plan = parseInt(state.plan, 10);
      } else if (subscriptionEnabled && state.weightKey) {
        // Engångsköp: stämpla vilken plan (vikt×storlek) som SKULLE gällt – varukorgens
        // pren-nudge (svd-cart-subswap) erbjuder då exakt rätt leveransintervall.
        var swapPlan = (selRow.getAttribute('data-plan-' + state.weightKey) || '').trim();
        var swapDays = parseInt(selRow.getAttribute('data-days-' + state.weightKey), 10) || 0;
        if (swapPlan) {
          items[0].properties = { '_svd_plan': swapPlan };
          if (swapDays > 0) { items[0].properties['_svd_days'] = String(swapDays); }
        }
      }

      // Hundvikt (2026-11-02): vald viktklass vid köpet följer med till ordern — även förvalet
      // (w2 = 11-30 vid sidladdning), Eriks beslut. Fast kod oberoende av knapptext/språk.
      // Ingen motor läser fältet.
      var HUNDVIKT = { w1: '0-10', w2: '11-30', w3: '30+' };
      if (HUNDVIKT[state.weightKey]) {
        items[0].properties = items[0].properties || {};
        items[0].properties['_hundvikt'] = HUNDVIKT[state.weightKey];
      }

      // GWP via svd.gwp_rule-metafältet: lägg varje gåva med _gwp-flaggan (gwp-motorn gör dem gratis).
      // subscription_only=true → bara i prenumerationsläge.
      // main_variant_ids → gåvan gäller bara listade huvudvarianter (t.ex. Tjurmuskel ej på 150g).
      var mainVariantId = parseInt(selRow.getAttribute('data-variant-id'), 10);
      // _gwp_main/_gwp_min (2026-08-21): huvudproduktens id + minsta kvalificerande antal
      // stämplas på gåvoraden så varukorgen (syncGwp i svd-cart.js) kan ta bort gåvor
      // vars huvudprodukt försvunnit — gwp-motorn slutar då rabattera och kunden skulle
      // debiteras (0 kr-prissatta gåvor som böckerna låge annars kvar gratis för evigt).
      // PRODUKT-id, inte variant-id: motorns villkor räknar på produktnivå, och en
      // storleksuppgradering i korgen byter variant men ska inte fälla gåvan.
      // Motorn läser bara _gwp-attributet — extra properties påverkar den inte.
      var mainProductId = root.getAttribute('data-product-id') || '';
      gwpGifts.forEach(function (gift) {
        if (!gift || (!gift.gift_variant_id && !gift.gift_variant_by_locale)) return;
        var gwpAllowed = !gift.subscription_only || state.mode === 'subscription';
        if (gift.onetime_only && state.mode === 'subscription') gwpAllowed = false;
        if (Array.isArray(gift.main_variant_ids) && gift.main_variant_ids.length > 0) {
          var qualifies = gift.main_variant_ids.some(function (id) { return parseInt(id, 10) === mainVariantId; });
          if (!qualifies) gwpAllowed = false;
        }
        var minQty = parseInt(gift.min_main_quantity, 10);
        if (minQty > 0 && qty < minQty) gwpAllowed = false;
        var gwpId = gwpVariantFor(gift);
        if (gwpAllowed && gwpId > 0) {
          var gwpQty = parseInt(gift.gift_quantity, 10);
          var gwpProps = { '_gwp': 'true' };
          if (mainProductId) {
            gwpProps['_gwp_main'] = mainProductId;
            gwpProps['_gwp_min'] = String(minQty > 0 ? minQty : 1);
          }
          items.push({ id: gwpId, quantity: gwpQty > 0 ? gwpQty : 1, properties: gwpProps });
        }
      });

      cta.setAttribute('data-loading', 'true');
      cta.setAttribute('disabled', 'disabled');

      // Med UpCart räcker cart-bubblan — rendera inte hela drawern i onödan
      var wantedSections = hasUpCart() ? 'cart-bubble' : 'cart-drawer,cart-bubble';

      // Upsell-popup: erbjud kundens deals FÖRE köpet (spegel av v1).
      var maybeOffer = (window.SvdUpsellPopup && typeof window.SvdUpsellPopup.offer === 'function')
        ? window.SvdUpsellPopup.offer()
        : Promise.resolve([]);

      maybeOffer
        .then(function (upsellIds) {
          (upsellIds || []).forEach(function (uid) {
            var pid = parseInt(uid, 10);
            if (pid > 0) items.push({ id: pid, quantity: 1, properties: { '_popup_deal': '1' } });
          });
          var svdRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return fetch(svdRoot + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: items,
              sections: wantedSections,
              sections_url: window.location.pathname
            })
          });
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e && e.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function (response) {
          try { root.dispatchEvent(new CustomEvent('svd:picker:added', { bubbles: true })); } catch (e) { /* svd-kontrakt */ }
          if (hasUpCart()) {
            renderDrawerSections(response);
            tryOpenUpCart();
          } else if (document.getElementById('SvdNotis')) {
            /* SVD Notis-sektionen visar bekräftelsen (fångar /cart/add-anropet
               själv) – stanna kvar på sidan så kunden kan fortsätta handla. */
          } else if (!openThemeCartDrawer(response)) {
            window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          }
        })
        .catch(function (err) {
          console.error('[svd-bundle-v2] add-to-cart error', err);
          alert('Något gick fel. Försök igen.');
        })
        .finally(function () {
          cta.removeAttribute('data-loading');
          renderCta();
        });
    }

    // ============== Listeners (spegel av v1) ==============
    weightButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setWeight(btn.getAttribute('data-bundle-weight'));
      });
    });

    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        setMode(btn.getAttribute('data-bundle-mode'));
      });
    });

    variants.forEach(function (v) {
      v.addEventListener('click', function (e) {
        if (v.getAttribute('data-available') === 'false') {
          e.preventDefault();
          return;
        }
        selectVariant(v);
      });
      var radio = v.querySelector('[data-bundle-radio]');
      if (radio) {
        radio.addEventListener('change', function () {
          selectVariant(v);
        });
      }
    });

    cta.addEventListener('click', addToCart);

    // Pren-teaserns länk i engångsläget (Grand Slam): växla till prenumerationsläget.
    Array.prototype.forEach.call(root.querySelectorAll('[data-bundle-goto-sub]'), function (el) {
      el.addEventListener('click', function () { setMode('subscription'); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setMode('subscription'); }
      });
    });

    // Initial state — läge före vikt, sedan förvald viktgrupp 'w2' (spegel av v1)
    setMode(state.mode);
    setWeight('w2');
    selectVariant(state.selectedRow);
  }

  // ============== Mount all instances ==============
  function mountAll() {
    var roots = document.querySelectorAll('.svd-b2');
    Array.prototype.forEach.call(roots, initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  // Shopify Theme Editor live preview
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:block:select', mountAll);
  /* svd-kontrakt (Claude 2026-09-25): montera väljare som injicerats i produktkortets
     "Lägg till"-blad (assets/svd-popup-quickadd.js) — bara rötter i e.detail.root. */
  document.addEventListener('svd:picker:mount', function (e) {
    var host = e && e.detail && e.detail.root;
    if (!host || !host.querySelectorAll) return;
    Array.prototype.forEach.call(host.querySelectorAll('.svd-b2'), initBundle);
  });
})();
